<script setup>
const props = defineProps({
  visible: Boolean,
  customClass: Object,
});

const emit = defineEmits(['toggleTooltip', 'closeTooltip']);

const tooltipRef = ref(null);

const toggleTooltip = () => emit('toggleTooltip');

const closeTooltip = () => emit('closeTooltip');

const handleClickOutside = (event) => {
  if (tooltipRef.value && !tooltipRef.value.contains(event.target)) {
    closeTooltip();
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>

<template>
  <div ref="tooltipRef" :class="customClass || 'tooltip-container'">
    <button class="tooltip-button" @click="toggleTooltip">
      <i class="tooltip-button__icon"></i>
    </button>

    <div v-if="visible" class="tooltip-pop">
      <button class="tooltip-close" @click="closeTooltip">
        <i class="tooltip-close__icon"></i>
      </button>

      <slot name="tooltip-pop__content">
        <div class="tooltip-pop__content"></div>
      </slot>
    </div>
  </div>
</template>